/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import {
    object, arrayOf, shape, string, func,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ReactMarkdown from 'react-markdown';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';

const styles = (theme) => ({
    title: {
        padding: '10px 15px 10px',
        fontFamily: theme.typography.fontFamily,
        textAlign: 'left',
        postion: 'relative',
        '& h6': {
            fontSize: '1rem;',
            fontWeight: '600',
            borderBottom: '2px solid',
            padding: '5px 0px',
            borderBottomColor: theme.palette.modalBg,
        },
    },

    dialogMain: {
        '& div': {
            '& div': {
                borderRadius: 'initial',
                maxWidth: '960px',
                width: '100%',
            },
        },
    },
    closeIcon: {
        position: 'absolute',
        top: '13px',
        right: '13px',
        cursor: 'pointer',
    },
    titleText: {
        color: theme.palette.colorIconHeader,
        fontSize: '14px',
    },
    dialogContent: {
        fontSize: '14px',
        color: theme.palette.grey1,
    },
});

const WineDisclaimer = ({
    classes,
    data,
    oncloseDialog,
}) => {
    const title_wine = data?.findContent?.content?.entries?.[0]?.title;
    const image = data?.findContent?.content?.entries?.[0]?.spots?.[0]?.content_spot?.content;
    return (
        <Dialog fullscreen open className={classes.dialogMain}>
            <DialogTitle className={classes.title} id="form-dialog-title">
                <span className={classes.titleText}>
                    {title_wine}
                </span>
                <span role="presentation" onClick={oncloseDialog}>
                    <CloseIcon className={classes.closeIcon} />
                </span>
            </DialogTitle>
            <DialogContent>
                <ReactMarkdown source={image} />
            </DialogContent>
        </Dialog>
    );
};
WineDisclaimer.propTypes = {
    classes: object.isRequired,
    oncloseDialog: func.isRequired,
    data: shape({
        findContent: shape({
            content: shape({
                entries: arrayOf(shape({
                    title_wine: string.isRequired,
                    spots: arrayOf(shape({
                        content_spot: shape({
                            content: string.isRequired,
                        }),
                    })),
                })),
            }),
        }),
    }).isRequired,
};
export default withStyles(styles)(WineDisclaimer);
